import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {OrganigrammeComponent} from './feature/organigramme/organigramme.component'
import {ExporterDelegationsComponent} from "./feature/exporter-delegations/exporter-delegations.component";

@NgModule({
    imports: [
        CommonModule,
        OrganigrammeComponent,
        ExporterDelegationsComponent,
    ],
    providers: [],
    exports: [],
})
export class OrganigrammeModule {}
